import React from "react";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { ROUTE_TITLES } from "../../../constants/constants";
import Footer from "../../primitives/Footer";
import PublicNav from "../landingPage/components/publicNav";

const PublicRoute = () => {
  const location = useLocation();
  const { pathname } = location;
  const title = Object.keys(ROUTE_TITLES).find((title) =>
    pathname.includes(title),
  );
  const isFooterHidden = pathname === "/personalize";

  const [searchParams] = useSearchParams();
  const isGoogleSignUp = Boolean(searchParams.get("isGoogleSignUp"));

  if (isGoogleSignUp)
    return (
      <div className="flex flex-col h-full justify-between">
        <Outlet />
      </div>
    );

  return (
    <div className="flex flex-col h-full justify-between">
      <div>
        {!!title ? <PublicNav title={ROUTE_TITLES[title]} /> : null}
        <Outlet />
      </div>
      <div className={`${isFooterHidden ? "hidden" : ""}`}>
        <Footer />
      </div>
    </div>
  );
};

export default PublicRoute;
